import React, { useState,useEffect } from 'react';
import { useAuth0 } from '../hooks/useAuth0';
import api from '../services/api';

const ChangePasswordButton = () => {
  const { user } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [profileEmail, setProfileEmail] = useState(null);
  // Only show for Auth0 username/password users
  // Google OAuth users manage password via Google
  const isPasswordUser = user?.sub?.startsWith('auth0|');

  useEffect(() => {
    const fetchEmail = async () => {
      try {
        const response = await api.get('/v1/patients/profile');
        setProfileEmail(response.data.email);
      } catch (e) {
        // Fallback to Auth0 email if profile fetch fails
        setProfileEmail(user?.email);
      }
    };
    if (isPasswordUser) fetchEmail();
  }, [isPasswordUser, user]);

  const handleChangePassword = async () => {
    try {
      setLoading(true);
      setError(null);
      await api.post('/v1/auth/change-password');
      setSent(true);
    } catch (e) {
      setError('Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isPasswordUser) {
    return (
      <div style={{
        padding: '12px 16px',
        background: '#f1f5f9',
        borderRadius: 10,
        fontSize: 13,
        color: '#64748b',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}>
        🔵 Your password is managed by Google.
        <a href="https://myaccount.google.com/security"
           target="_blank" rel="noreferrer"
           style={{ color: '#1a5fa8', fontWeight: 600 }}>
          Change it here →
        </a>
      </div>
    );
  }

  if (sent) {
    return (
      <div style={{
        padding: '12px 16px',
        background: '#d1fae5',
        borderRadius: 10,
        fontSize: 13,
        color: '#059669',
        fontWeight: 600,
      }}>
        ✅ Password reset email sent to {user.email}. Check your inbox!
      </div>
    );
  }

  return (
    <div>
      <button
        onClick={handleChangePassword}
        disabled={loading}
        style={{
          padding: '10px 20px',
          background: loading ? '#e2e8f0' : 'linear-gradient(135deg,#1a5fa8,#2d9de8)',
          color: loading ? '#94a3b8' : 'white',
          border: 'none',
          borderRadius: 10,
          fontFamily: "'DM Sans',system-ui,sans-serif",
          fontWeight: 700,
          fontSize: 14,
          cursor: loading ? 'not-allowed' : 'pointer',
          transition: 'all .2s',
        }}
      >
        {loading ? '⏳ Sending...' : '🔑 Change Password'}
      </button>
      {error && (
        <p style={{ fontSize: 13, color: '#dc2626', marginTop: 8 }}>{error}</p>
      )}
      <p style={{ fontSize: 12, color: '#94a3b8', marginTop: 6 }}>
        We'll send a password reset link to {user?.email}
      </p>
    </div>
  );
};

export default ChangePasswordButton;